/*  STRAIGHT TO CHECKOUT.

    The buy buttons used to go to /products/echo-valley, which renders with the old
    Impulse template. So the path was: a landing page built to sell this plug-in, then
    a stock product page that looks nothing like it, then a cart page, then checkout.
    Three chances to lose someone, two of them looking like a different shop.

    This adds the item and jumps to Shopify's checkout. The landing page IS the product
    page here: it has the demos, the engines, the specs and the trial. The stock one was
    adding a photo and a paragraph.

    NO MARKUP CHANGES ON THE SELLING PAGES. It intercepts product links inside .ev-root
    and works out the variant by asking Shopify for the product, so it keeps working if
    the price, the handle or the variant ever change.

    BROWSE SURFACES OPT OUT, and that is the whole reason this file has been edited twice.
    The rule above was written when .ev-root only ever wrapped the Echo Valley landing
    page, where a product link could only be a buy button. Two things have broken that
    since. The top bar arrived carrying .ev-root of its own and its search panel lists
    products, so picking a search result added that kit to the cart and threw you at
    checkout instead of opening it. Then the shop grid arrived, which is an entire wall of
    product links and not one of them is a buy button.

    The first fix named .ev-topnav-bar directly and that was wrong: it fixed the panel and
    would have shipped the grid broken in exactly the same way. Naming surfaces one at a
    time loses this race forever, because the next grid or panel is always unwritten. So
    the container declares itself instead. Anything carrying data-ev-browse is a place for
    reading and choosing, never for buying, and everything inside it is left alone. A new
    browse surface adds one attribute and cannot reintroduce this.

    PROGRESSIVE ENHANCEMENT, and it matters more here than anywhere else on the site:
    every failure path falls back to letting the link do what it always did. A buy
    button that does nothing because a script hiccuped is the most expensive bug this
    site could have.  */
(function () {
  'use strict';

  function handleFrom (a) {
    // "/products/echo-valley" or "/products/echo-valley?variant=123"
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.ev-root a[href*="/products/"]') : null;
    if (!a) return;
    if (a.closest('[data-ev-browse]')) return;   // somewhere to read, not somewhere to buy
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;  // let people open a new tab

    var handle = handleFrom(a);
    if (!handle) return;

    e.preventDefault();
    a.style.pointerEvents = 'none';          // one click, not three

    /*  THE FALLBACK HAS TO LEAD SOMEWHERE NEW. Everywhere else a buy link points at
        the product page, which can sell on its own, so following it is a real way
        forward. On /products/echo-valley the landing page IS the product page, and
        following the link would reload the page the button sits on: a buy button
        that looks like it does nothing. There the fallback is a cart permalink,
        built from the variant Shopify prints into every product page, which reaches
        checkout with no help from this script.  */
    var fail = function () {
      var target = new URL(a.href, location.origin);
      if (target.pathname === location.pathname) {
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        var variants = meta && meta.product && meta.product.variants;
        var id = target.searchParams.get('variant') || (variants && variants[0] && variants[0].id);
        if (id) { window.location.href = '/cart/' + id + ':1'; return; }
      }
      window.location.href = a.getAttribute('href');
    };

    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (p) {
        // Explicit variant on the link wins; otherwise the first one that can be sold.
        var want = new URL(a.href, location.origin).searchParams.get('variant');
        var v = null;
        if (want) v = p.variants.filter(function (x) { return String(x.id) === want; })[0];
        if (!v)   v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        if (!v) return Promise.reject();

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(fail);
  });
})();
